export default "__VITE_ASSET__QMS7$1Re__"